import 'whatwg-fetch';
import React from 'react';
import Media from 'react-media';
import {insertRule} from 'glamor';
import {ThemeProvider, Div} from 'glamorous';
import 'glamor/reset';

import Desktop from './Desktop';
import Mobile from './Mobile';
import Modal from './Modal';
import theme from './theme';

insertRule(`
html, body {
  font-family: Sailec-Regular, sans-serif;
}

#root {
  display: flex;
}`);

export default class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
  }
  render = () =>
    <ThemeProvider theme={theme}>
      <Div width="100%">
        <Div
          width="100%"
          position={this.state.isModalOpen ? 'fixed' : undefined}
        >
          <Media query="(max-width: 1100px)">
            {match =>
              match
                ? <Mobile onOpenModal={this.openModal} />
                : <Desktop onOpenModal={this.openModal} />}
          </Media>
        </Div>
        <Modal isOpen={this.state.isModalOpen} onCloseModal={this.closeModal} />
      </Div>
    </ThemeProvider>;

  openModal = () => this.setState({isModalOpen: true});

  closeModal = () => this.setState({isModalOpen: false});
}



// WEBPACK FOOTER //
// ./src/pages/Landing/index.js